<div class="no-content">
    <section class="no-content-description">
        <h1>¡Vaya!</h1>
        <h3>Todavía no hay algo que ver aquí.</h3>
        <p>Parece que esta página no tiene contenido para mostrar por el momento.</p>
    </section>
    <img src="assets/images/no-content.svg" alt="Página no encontrada" />
</div>